/* globals plausible */
export default async (_data) => {
  // const domain = "oehschauthin.at"
  // const url = `${window.location.origin}/${document.documentElement.lang}/${data}${window.location.search}`
  //
  // await fetch("/api/event", {
  //   method: "POST",
  //   body: JSON.stringify({
  //     name: "pageview",
  //     url: url,
  //     domain: domain,
  //   }),
  // })
}
